import React, { Suspense } from "react";
import { Switch, Route, Redirect } from "react-router-dom";

import MyWebsites from "./features/myWebsites/index";
import Dashboard from "./features/dashboard/index";

import AppBar from "./components/surfaces/appBar";
import LoginPage from "./features/login/index";
import AutoLogin from "./features/autoLogin/index";

import Master from "./components/master/index";
import NotFound from "./features/errorPages/404";
import ErrorPage from "./features/errorPages/503";
import Skeleton from "@material-ui/lab/Skeleton";
import { Box } from "@material-ui/core";

const Router = () => (
  <Switch>
    <Redirect exact from="/" to="/my-websites" />
    <Route
      exact
      path="/my-websites/:id"
      render={(props) => (
        <Master>
          <AppBar title={"My Websites"}>
            <MyWebsites match={props.match}></MyWebsites>
          </AppBar>
        </Master>
      )}
    ></Route>
    <Route
      exact
      path="/my-websites"
      render={(props) => (
        <Master>
          <AppBar title={"My Websites"}>
            <Suspense
              fallback={
                <Box mb={3}>
                  <Skeleton
                    variant="rect"
                    animation="wave"
                    height={94}
                  ></Skeleton>
                </Box>
              }
            >
              <MyWebsites {...props}></MyWebsites>
            </Suspense>
          </AppBar>
        </Master>
      )}
    ></Route>
    <Route exact path="/dashboard">
      <Master>
        <AppBar title={"Dashboard"}>
          <Dashboard></Dashboard>
        </AppBar>
      </Master>
    </Route>
    <Route exact path="/login">
      <Master LoginNotRequired>
        <LoginPage></LoginPage>
      </Master>
    </Route>
    <Route exact path="/autologin">
      {() => {
        if (document.getElementById("token") === null) {
          window.localStorage.clear();
          window.location = "/login";
        } else {
          var tempToken = document.getElementById("token").value;
          var customerId = document.getElementById("customerId").value;
          return <AutoLogin Token={tempToken} CustomerId={customerId}></AutoLogin>;
        }
      }}
    </Route>
    <Route exact path="/503" component={ErrorPage}></Route>
    <Route component={NotFound}></Route>
  </Switch>
);

export default Router;
